import { render, staticRenderFns } from "./details.vue?vue&type=template&id=5aca86d0&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=5aca86d0&prod&lang=scss"
import style1 from "./details.vue?vue&type=style&index=1&id=5aca86d0&prod&lang=css"
import style2 from "./details.vue?vue&type=style&index=2&id=5aca86d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca86d0",
  null
  
)

export default component.exports